// CMSContext.jsx
import React, { createContext, useState } from 'react';

export const CMSContext = createContext();

export const CMSProvider = ({ children }) => {
  const [buildingIds, setBuildingIds] = useState([]);
  const [buildings, setBuildings] = useState([]);
  const [devices, setDevices] = useState([]);
  const [gateDevices, setGateDevices] = useState([]);
  const [token, setToken] = useState(null);

  const clearAllCMSData = () => {
    setBuildingIds([]);
    setBuildings([]);
    setDevices([]);
    setGateDevices([]);
    setToken(null);
  };

  return (
    <CMSContext.Provider
      value={{
        buildingIds,//the id of the building that the panel is in
        setBuildingIds,
        buildings,//the data of the buildings
        setBuildings,
        devices,//the devices in the building
        setDevices,
        gateDevices,//the gate devices in the building
        setGateDevices,
        token,//the token to access the api
        setToken,
        clearAllCMSData
      }}
    >
      {children}
    </CMSContext.Provider>
  );
};